export default __webpack_public_path__ + "static/media/loginpng.46f5ac03.png";